module.exports = require('./readable').PassThrough



// WEBPACK FOOTER //
// ./~/stream-browserify/~/readable-stream/passthrough.js